module.exports = __webpack_public_path__ + "static/media/happiness.979452ab.png";